/**
 * agentDomains.ts — canonical agent-domain taxonomy.
 *
 * Extracted from OnboardingModal.jsx's CATEGORIES (the ids saved as
 * `onboarding.domains`), so this is the one list new UI reads from. Maps to
 * CustomAgent/AgentDefinition.category — a field that already exists on the
 * schema but, before this, had no UI anywhere to set it.
 *
 * This is also the list Settings' "Domain Folders" (UserProfileDisplay.tsx)
 * renders — both read/write the same `user.onboarding.domains` field, so
 * they need to share one id vocabulary to actually stay in sync.
 *
 * Deliberately NOT the same list as the skill-library's capability-type
 * categories (research/data/productivity/...) — that's a different axis
 * that happens to share the word "domain".
 */

export interface AgentDomain {
  id: string;
  label: string;
}

export const AGENT_DOMAINS: AgentDomain[] = [
  { id: 'general',   label: 'General' },
  { id: 'coding',    label: 'Engineering' },
  { id: 'finance',   label: 'Finance' },
  { id: 'product',   label: 'Product' },
  { id: 'marketing', label: 'Marketing' },
  { id: 'hr',        label: 'HR' },
  { id: 'legal',     label: 'Legal' },
  { id: 'founders',  label: 'Founders' },
];

export function agentDomainLabel(id?: string | null): string {
  return AGENT_DOMAINS.find((d) => d.id === id)?.label || 'General';
}
